import React, { useState, useEffect } from 'react'
import { useParams, useSearchParams, useNavigate } from 'react-router-dom'
import { getDepartmentById } from '../api/Index'
import './DepartmentDetails.css'
import PageTitle from '../components/UI/PageTitle'
import { CiEdit } from 'react-icons/ci'
import { useAuth } from '../api/Authcontext'

const DepartmentDetails = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { userData } = useAuth();
    const departmentId = id || searchParams.get('id');
    
    const [department, setDepartment] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!departmentId) {
            setError('Department ID not provided');
            return;
        }

        const fetchDepartment = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await getDepartmentById(departmentId);
                setDepartment(response.data);
            } catch (err) {
                setError(err.message);
                console.error('Error fetching department details:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchDepartment();
    }, [departmentId]);

    const handleEditDepartment = () => {
        navigate(`/edit-department?id=${departmentId}`);
    };


    if (loading) {
        return (
            <div>
                <PageTitle title="Loading..." />
                <div>Loading department details...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div>
                <PageTitle title="Error" />
                <div style={{color: 'red'}}>Error: {error}</div>
            </div>
        );
    }

    if (!department) {
        return (
            <div>
                <PageTitle title="Not Found" />
                <div>Department not found.</div>
            </div>
        );
    }

    return (
        <div>
            <PageTitle title={department.name || 'Department Details'} />
            {userData?.role === 'admin' && (
                <button onClick={handleEditDepartment}>
                    <CiEdit />Edit Department
                </button>
            )}
            <div className="">
                <h3 style={{ fontWeight: 'bold', color: 'grey' }}>DEPARTMENT DETAILS</h3>
                <h4>DESCRIPTION</h4>
                <p>{department.description || 'No description available'}</p>
                <h4>MEMBER INFORMATION</h4>
                <p>Head: {typeof department.head === 'object' ? department.head?.name || 'Unknown' : department.head || 'Not assigned'}</p>
                <p>Members: {department.members?.length || department.memberCount || 'N/A'}</p>
                <h4>DATES</h4>
                <p>Created At: {department.createdAt ? new Date(department.createdAt).toLocaleDateString() : 'Unknown'}</p>
                <h4>MEMBER LIST</h4>
                <ul>
                    {department.members && department.members.length > 0 ? (
                        department.members.map((member, index) => (
                            <li key={member._id || index}>
                                <strong>{member.name || member.user?.name}</strong> 
                                {member.role && ` - ${member.role}`}
                            </li>
                        ))
                    ) : (
                        <li>No members assigned yet.</li>
                    )}
                </ul>

                <h4>DEPARTMENT ACTIVITIES</h4>
                {department.activities && department.activities.length > 0 ? (
                    <div className="activities-section">
                        <table className="activities-table">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Description</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Budget (KES)</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {department.activities.map((activity, index) => (
                                    <tr key={index}>
                                        <td><strong>{activity.title}</strong></td>
                                        <td>{activity.description || 'No description'}</td>
                                        <td>
                                            {activity.startDate 
                                                ? new Date(activity.startDate).toLocaleDateString() 
                                                : 'Not set'
                                            }
                                        </td>
                                        <td>
                                            {activity.endDate 
                                                ? new Date(activity.endDate).toLocaleDateString() 
                                                : 'Not set'
                                            }
                                        </td>
                                        <td>
                                            {activity.budget 
                                                ? activity.budget.toLocaleString() 
                                                : 'Not specified'
                                            }
                                        </td>
                                        <td>
                                            <span className={`status-badge status-${activity.status}`}>
                                                {activity.status || 'planned'}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p>No activities scheduled for this department.</p>
                )}
            </div>
        </div>
    )
}

export default DepartmentDetails